import React from 'react';
import ReactDOM from 'react-dom';

import Button from 'react-bootstrap/Button';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Jumbotron from 'react-bootstrap/Jumbotron';

import Form from 'react-bootstrap/Form';

import PopupBox from '../PopupBox.js';

import Countdown from '../Countdown.js';



export default class RyanAir extends React.Component {


    constructor(props){
        super(props);
        this.state = {
            correct: false,
            selected: ""
        }
      }


  render() {




    //handle the click on one of the buttons
    const handleSelect = (e) => {

        e.preventDefault()

        console.log("select", e.target.value)
        
        this.setState({
          selected: e.target.value
        })


      


        //check if all ticks are off


    };





    //handle the click on one of the buttons
    const handleClick = (e) => {

      //if the id value of the button and compare to the correct answer
      console.log("selected:",this.state.selected)

      console.log("correct:",this.props.correct_answer1,this.props.correct_answer2,this.props.correct_answer3)
      


      if( this.state.selected == this.props.correct_answer1 || this.state.selected == this.props.correct_answer2 || this.state.selected == this.props.correct_answer3)
      { 
        this.props.setResult(true, this)
      }
      else
      {
        this.props.setResult(false, this)
      }


      






    };



    let position = "_"

    position = this.props.getPos(this)

    console.log(position)
    
    
    var countries0 = "Afghanistan, Albania, Algeria, Andorra, Angola, Antigua & Deps, Argentina, Armenia, Australia, Austria, Azerbaijan, Bahamas, Bahrain, Bangladesh, Barbados, Belarus, Belgium, Belize, Benin, Bhutan, Bolivia, Bosnia Herzegovina, Botswana, Brazil, Brunei, Bulgaria, Burkina, Burundi, Cambodia, Cameroon, Canada, Cape Verde, Central African Rep, Chad, Chile, China, Colombia, Comoros, Congo, Costa Rica, Croatia, Cuba, Cyprus, Czech Republic".split(", ")
    var countries1 = "Denmark, Djibouti, Dominica, Dominican Republic, East Timor, Ecuador, Egypt, El Salvador, Equatorial Guinea, Eritrea, Estonia, Ethiopia, Fiji, Finland, France, Gabon, Gambia, Georgia, Germany, Ghana, Greece, Grenada, Guatemala, Guinea, Guinea-Bissau, Guyana, Haiti, Honduras, Hungary, Iceland, India, Indonesia, Iran, Iraq, Ireland, Israel, Italy, Ivory Coast, Jamaica, Japan, Jordan, Kazakhstan, Kenya, Kiribati, Korea North, Korea South, Kosovo, Kuwait, Kyrgyzstan, Laos, Latvia, Lebanon, Lesotho, Liberia, Libya, Liechtenstein, Lithuania, Luxembourg, Macedonia, Madagascar, Malawi, Malaysia, Maldives, Mali, Malta, Marshall Islands, Mauritania, Mauritius, Mexico, Micronesia, Moldova, Monaco, Mongolia, Montenegro, Morocco, Mozambique, Myanmar, Namibia, Nauru, Nepal, Netherlands, New Zealand, Nicaragua, Niger, Nigeria, Norway".split(", ")

    var countries2 = "Oman, Pakistan, Palau, Panama, Papua New Guinea, Paraguay, Peru, Philippines, Poland, Portugal, Qatar".split(", ")
    var countries3 = "Romania, Russian Federation, Rwanda, St Kitts & Nevis, St Lucia, Saint Vincent & the Grenadines, Samoa, San Marino, Sao Tome & Principe, Saudi Arabia, Senegal, Serbia, Seychelles, Sierra Leone, Singapore, Slovakia, Slovenia, Solomon Islands, Somalia, South Africa, South Sudan, Spain, Sri Lanka, Sudan, Suriname, Swaziland, Sweden, Switzerland, Syria, Taiwan, Tajikistan, Tanzania, Thailand, Togo, Tonga, Trinidad & Tobago, Tunisia, Turkey, Turkmenistan, Tuvalu, Uganda, Ukraine, United Arab Emirates, United Kingdom, United States, Uruguay, Uzbekistan, Vanuatu, Vatican City, Venezuela, Vietnam, Yemen, Zambia, Zimbabwe".split(", ")

    var options = []


        for(var i = 0; i < countries0.length; i ++)
        {
            options.push( <option>{countries0[i]}</option> )
        }

        options.push( <option>{this.props.correct_answer1}</option> )


        for(var i = 0; i < countries1.length; i ++)
        {
            options.push( <option>{countries1[i]}</option> )
        }

        options.push( <option>{this.props.correct_answer2}</option> )

        for(var i = 0; i < countries2.length; i ++)
        {
            options.push( <option>{countries2[i]}</option> )
        }

        options.push( <option>{this.props.correct_answer3}</option> )

        for(var i = 0; i < countries3.length; i ++)
        {
            options.push( <option>{countries3[i]}</option> )
        }

       
    

    return (




      <PopupBox position={this.props.position} getPos={this.props.getPos} question={this}>


      <Countdown time_allowed={60} getPos={this.props.getPos} question={this} setResult={this.props.setResult}></Countdown>


          
     
        <h2 className="text-danger">{this.props.question}</h2>

        
        <br></br>

        <div className="d-flex justify-content-center">
          
        <Form.Control id="ryanair_country_select" className="m-3" onChange={handleSelect} as="select" size="lg">
            {options}
        </Form.Control>

        <ButtonToolbar>
            <Button onMouseDown={handleClick} className="ml-1" variant="success" size="lg">Submit</Button>
          </ButtonToolbar>


        </div>

      </PopupBox>

    );
  }
}
